import { useGetUsersByQueryQuery } from 'API/UserApi';
import React, { useMemo } from 'react';
import { IStandardDocumentData } from 'types/order/documents/shared/interfaces';
import { IGetUser } from 'types/users/IUser';
import { getDateString } from '../../../../../ui-toolkit/utilities/getDateString';

export interface IDocumentUploadedProps {
  document: IStandardDocumentData;
}

export const DocumentUploaded: React.FC<IDocumentUploadedProps> = ({ document }) => {
  const user = { userType: document.uploaderType, userId: document.uploaderId } as IGetUser;
  const { data: users } = useGetUsersByQueryQuery([user]);

  const uploadedAt = useMemo(() => {
    return document.updatedAt;
  }, [document]);
  return (
    <>
      <div>{users && users[0].name}</div>
      <div>
        {getDateString('M/d/yyyy', uploadedAt)} @{getDateString('HH:mma', uploadedAt)}
      </div>
    </>
  );
};
